import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/achievements/_components/achivements-container.tsx");
